<span *appFeatureFlag="'isFacebookAvailable'" class="social-item-wrapper">
  <a href="https://www.facebook.com/Identibase/"
    target="_blank"
    aria-label="identi on Facebook"
    class="socials-icon">
    <div class="blob-wrapper" [ngClass]="badgeStyleClass"
     [ngStyle]="{ 'width': badgeWrapperSize, 'height': badgeWrapperSize }">
      <svg  class="blob"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="252"
            height="240"
            viewBox="0 0 252 240">
        <defs>
          <path
            id="a-1"
            d="M206.398 210.163C179.015 238 79.817 259.67 31.034 211.704-17.748 163.737-1.79 68.167 29.493 36.34c53.316-54.223 120.687-43.614 169.56 4.443 48.965 47.876 61.296 114.522 7.345 169.38">
          </path>
        </defs>
        <g fill="none" fill-rule="evenodd" transform="translate(5)">
          <mask id="b-1" fill="#fff">
            <use xlink:href="#a-1"></use>
          </mask>
          <use fill-rule="nonzero" xlink:href="#a-1"></use>
          <g fill-rule="nonzero" mask="url(#b-1)">
            <path d="M-5-1h253v241H-5z"></path>
          </g>
        </g>
      </svg>
      <div class="blob-content">
        <fa-icon [ngStyle]="{ 'font-size': badgeIconSize }" [icon]="['fab', 'facebook-f']"></fa-icon>
      </div>
    </div>
  </a>
</span>
